module.exports = __webpack_public_path__ + "img/000000-img15.60ce5713.png";